/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FormAuditUpdateResponseDto } from '../models/form-audit-update-response-dto';
import { forms } from '../fn/auditing-reopen/forms';
import { Forms$Params } from '../fn/auditing-reopen/forms';

@Injectable({ providedIn: 'root' })
export class AuditingReopenService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formReopenControllerForms()` */
  static readonly FormReopenControllerFormsPath = '/auditing/reopen/forms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forms()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forms$Response(
    params: Forms$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormAuditUpdateResponseDto>>> {
    return forms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `forms$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forms(params: Forms$Params, context?: HttpContext): Observable<Array<FormAuditUpdateResponseDto>> {
    return this.forms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormAuditUpdateResponseDto>>): Array<FormAuditUpdateResponseDto> => r.body)
    );
  }
}
